import styled, { css } from 'styled-components';
import { NumberField } from '../numberField';
import { Field } from 'formik';

let fieldStyle = css`
  background: none;
  border: none;
  color: ${props => props.theme.colors.text};
  font-weight: 600;
  height: 30px;
  width: 100%;
  padding: 0;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: #d2c8c6;
  }

  &.small {
    height: 26px;
  }
`

export const StyledNumberField = styled(NumberField)`
  ${fieldStyle}
`

export const StyledField = styled(Field)`
  ${fieldStyle}
`;

export const StyledSelect = styled.select`
  ${fieldStyle}
`

export const StyledRadio = styled(Field)`
  position: absolute;
  left: -9999px;

  & + label {
    position: relative;
    padding-left: 28px;
    height: 20px;
    display: inline-block;
  }

  & + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 25px;
    height: 25px;
    border: 1px solid ${props => props.theme.colors.border};
    border-radius: 100%;
    background: #fff;
  }

  & + label:after {
    content: '';
    width: 13px;
    height: 13px;
    background: ${props => props.theme.colors.primary};
    position: absolute;
    top: 6px;
    left: 6px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }

  &:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }

  &:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
`

export const StyledErrorLabel = styled.label`
  background: #ffe9e6;
  color: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fontSizes.small};
  padding: 7px;
  display: block;
  margin-bottom: 5px;
  border-radius: ${props => props.theme.borderRadius};
`

export const IconWrapper = styled.span`
  font-size: 24px;
  left: 15px;
  margin: -13px 0 0 0;
  position: absolute;
  opacity: 0.2;
  top: 50%;
`

export const InputWrapper = styled.span`
  background: #fff;
  position: relative;
  display: block;
  border: 1px ${props => props.theme.colors.border} solid;
  border-radius: ${props => props.theme.borderRadius};
  padding: 7px 10px 5px 10px;
  text-align: left;
`

export const StyledLabel = styled.label`
  color: ${props => props.theme.colors.primary};
  text-transform: uppercase;
  font-size: ${props => props.theme.fontSizes.extraSmall};
`;

export const StyledWrapper = styled.div`
  width: 100%;

  & + &, & + .row {
    margin-top: 10px;
  }
`

export const StyledBrand = styled.div`
  position: absolute;
  right: 10px;
  bottom: 8px;
`
